module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/store_images/1_9363aea7169154198fffe22cd8603bd2.png";